import { Injectable } from "@angular/core";
import { DataService } from "../DataService/data.service";
import { Observable } from "rxjs";
import { APIName } from "../../Models/APIEndPoints/APIName";
import { IBaseDataList } from "src/app/Models/Interface/Base/base-data-list";
import { IAccount } from "src/app/Models/Interface/Account/account";
import { IPagination } from "src/app/Models/Interface/Pagination/pagination";
import { HttpParams } from "@angular/common/http";
import { IBuyerUsers } from "src/app/Models/Interface/User/buyer-users";
import { IVessel } from "src/app/Models/Interface/ManageVessel/vessel";

@Injectable({
  providedIn: "root",
})
export class AccountService {
  pagination = {
    skip: 0,
    take: 15,
    pagesCount: 0,
    inPageNumber: 1,
    leftItems: 0,
  } as IPagination;
  empPagination = {
    skip: 0,
    take: 15,
    pagesCount: 0,
    inPageNumber: 1,
    leftItems: 0,
  } as IPagination;

  constructor(private dataService: DataService) {}

  getCompanies(): Observable<IBaseDataList<IAccount[]>> {
    let params = new HttpParams();
    // @ts-ignore
    params = params.append("skip", this.pagination.skip);
    params = params.append("take", this.pagination.take);
    return this.dataService.getWithParams(APIName.accounts.companies, params);
  }

  getClientsForMarihub(): Observable<IAccount[]> {
    return this.dataService.get(APIName.accounts.clientsForMarihub);
  }

  getEmployees(accountId: number): Observable<IBaseDataList<IBuyerUsers[]>> {
    let params = new HttpParams();
    // @ts-ignore
    params = params.append("skip", this.empPagination.skip);
    params = params.append("take", this.empPagination.take);
    params = params.append("accountId", accountId);
    return this.dataService.getWithParams(
      APIName.accounts.getEmployeesInCompany,
      params
    );
  }

  getClientsListForShoppingAs(): Observable<IBaseDataList<IAccount[]>> {
    return this.dataService.get(APIName.accounts.getClientsForShoppingAs);
  }

  getEmployeeForShoppingAs(
    clientId: number,
    categoryId: number
  ): Observable<IBaseDataList<IBuyerUsers[]>> {
    let params = new HttpParams();
    // @ts-ignore
    params = params.append("clientId", clientId);
    params = params.append("categoryId", categoryId);
    return this.dataService.getWithParams(
      APIName.accounts.getUsersListForShopAs,
      params
    );
  }

  getVesselsClient(
    accountId: number | null
  ): Observable<IBaseDataList<IVessel[]>> {
    let params = new HttpParams();
    // @ts-ignore
    if (accountId) params = params.append("accountId", accountId);
    return this.dataService.getWithParams(
      APIName.accounts.vesselClients,
      params
    );
  }
}
